import React, {Component} from 'react';
import _ from 'lodash';

export class StaticSelect extends Component {
  render() {
    const optionKey = _.get(this.props, 'value');
    const options = _.get(this.props, 'options');
    const option = _.find(options, (selection) => selection.key === optionKey);

    return <p>{option.text ? option.text : option.value}</p>;
  }
}
